import _ from 'lodash'
import { deflate, inflate } from 'pako'
import { Buffer } from 'buffer'

export class CompressorImpl {
  /**
   * Compress data using pako and return as base64 string
   * @param data
   */
  public compress(data: any): string {
    if (this.isCompressed(data)) {
      // already compressed, no-op
      return data
    }
    // best effor to compress
    try {
      const normalizedStr = _.isString(data) ? data : JSON.stringify(data)
      const compressedData = deflate(normalizedStr)
      return Buffer.from(compressedData).toString('base64')
    } catch (e) {
      console.error('>>>Unable to compress data', e, data)
    }

    return data
  }

  /**
   *  Decompress data and return as json object
   */
  public decompress(data: any): object {
    if (!this.isCompressed(data)) {
      // not a compressed data, just return
      console.log('>>>DEBUG<<<:already decompressed')
      return data
    }
    try {
      const compressed = Buffer.from(data, 'base64');
      const decompressed = inflate(compressed, { to: 'string' });
      return JSON.parse(decompressed);
    } catch (e) {
      console.error('>>>Unable to decompress data', e, data)
    }
    return data
  }
  /**
   *  Check if data is already compress or not
   */
  public isCompressed(data: any): boolean {
    return this.isBase64(data) && this.isZlibCompressedBase64(data)
  }

  private isZlibCompressedBase64(base64Str: string): boolean {
    try {
      const buffer = Buffer.from(base64Str, 'base64')
      // Check for zlib signature: first byte is always 0x78, second varies
      if (buffer.length < 2) return false
      const first = buffer[0]
      const second = buffer[1]
      return first === 0x78 && (second === 0x01 || second === 0x9c || second === 0xda)
    } catch {
      return false
    }
  }

  /**
   * Fast check to see if data is base64 without decoding it
   */
  private isBase64(data: any): boolean {
    if (typeof data !== 'string') return false

    // Check length is a multiple of 4
    if (data.length % 4 !== 0) return false

    // Basic base64 regex: letters, numbers, +, / and optional padding =
    const base64Regex = /^[A-Za-z0-9+/]+={0,2}$/
    return base64Regex.test(data)
  }
}

export const Compressor = new CompressorImpl()
